import {policySourceUrl,type OfficialSourceReference} from './policy';

/** Bibliographic reference selection is not an applicability or approval decision. */
export function OfficialSourceList({sources,onSelect}:{sources:OfficialSourceReference[];onSelect?:(source:OfficialSourceReference)=>void}){
 if(!sources.length)return null;
 return <section className="rs-calm-official" aria-label="공식 원문 참고자료">
  <p className="rs-calm-policy-note">공식 원문부터 살펴볼 수 있어요.</p>
  {sources.map(source=>{
   const url=policySourceUrl(source.canonicalUri);
   return <article key={source.sourceKey+source.observationKey} className="rs-calm-policy-document">
    <div className="rs-calm-policy-authority">{source.authorityName} · {source.documentYear}</div>
    <h2>{source.title}</h2>
    <div className="rs-calm-policy-meta">게시 {source.publishedOn} · 첨부 파일 확보</div>
    {url&&<a className="rs-calm-original" href={url} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer">공식 게시물 열기 ↗</a>}
    {onSelect&&<button className="rs-calm-link" onClick={()=>onSelect(source)}>계획 초안에 담기</button>}
    <details><summary>자료 확인 정보</summary><dl>
     <div><dt>확보한 형식</dt><dd>{source.formats.join(' · ')} ({source.attachmentCount}개 파일)</dd></div>
     <div><dt>확보 확인일</dt><dd>{new Date(source.observedAt).toLocaleDateString('ko-KR',{timeZone:'Asia/Seoul'})}</dd></div>
     <div><dt>학교 적용</dt><dd>별도 검토 전</dd></div>
     <div><dt>이용 방식</dt><dd>제목·출처·원문 링크만 제공</dd></div>
    </dl><p>원문 파일 확보와 제목을 확인한 자료입니다. 내용의 최신성·학교 의무를 확정한 것은 아니며, 원문 재배포·가공 이용조건은 별도 확인이 필요합니다.</p></details>
   </article>;
  })}
 </section>;
}
